module.exports = __webpack_public_path__ + "static/epress-f41846e90bd5040f7c3d18a616e7ddc3.jpg";